export enum PerDiemMethod {
  None = 0,
  RouteBased = 1,
  HOSBased = 2,
  WorkBased = 3,
  RouteBasedMiles = 4,
  WorkBasedWithFillIn = 5,
  WorkBasedTeamOnly = 6,
  HosDaysTeamOnly = 7
}

export const PerDiemMethodMapping: Record<PerDiemMethod, string> = {
  [PerDiemMethod.None]: 'None',
  [PerDiemMethod.RouteBased]: 'Route Based',
  [PerDiemMethod.HOSBased]: 'HOS Based',
  [PerDiemMethod.WorkBased]: 'Work Based',
  [PerDiemMethod.RouteBasedMiles]: 'Route Based Miles',
  [PerDiemMethod.WorkBasedWithFillIn]: 'Work Based [Fill In]',
  [PerDiemMethod.WorkBasedTeamOnly]: 'Work Based [Team Only]',
  [PerDiemMethod.HosDaysTeamOnly]: 'HOS Days [Team Only]'
};

export const PerDiemMethodForDays: PerDiemMethod[] = [
  PerDiemMethod.RouteBased,
  PerDiemMethod.HOSBased,
  PerDiemMethod.WorkBased,
  PerDiemMethod.WorkBasedWithFillIn,
  PerDiemMethod.WorkBasedTeamOnly,
  PerDiemMethod.HosDaysTeamOnly
];

export const PerDiemMethodForRates: PerDiemMethod[] = [PerDiemMethod.RouteBasedMiles];
